import {HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND, HTTP_UNAUTHORIZED} from "../../app/constants/status";
import {Toast} from "../../app/modules/common/helper";

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      if (config.showLoading !== false) {
        document.body.classList.add('page-loading')
      }
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }
      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      document.body.classList.remove('page-loading')
      return Promise.resolve(response)
    },
    (error: any) => {
      const config = error.config;

      if (!config.useLocal404Toast && error.response?.status === HTTP_NOT_FOUND) {
        Toast.fire({
          icon: 'error',
          title: 'Nội dung không tìm thấy'
        })
      }
      if (error.response?.status === HTTP_UNAUTHORIZED) {
        window.location.href = "/auth/login";
      }
      document.body.classList.remove('page-loading')
      if (error.response?.status === HTTP_INTERNAL_SERVER_ERROR) {
        let message = error.response?.data?.message ?? 'Thất bại. Vui lòng thử lại sau'
        Toast.fire({
          icon: 'error',
          title: message
        })
      }
      return Promise.reject(error)
    }
  );
}
